module.exports = "images/-12.29ecbeb3.png";